import { render, staticRenderFns } from "./updatePwdModal.vue?vue&type=template&id=beaa4fdc&scoped=true&"
import script from "./updatePwdModal.vue?vue&type=script&lang=js&"
export * from "./updatePwdModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePwdModal.vue?vue&type=style&index=0&id=beaa4fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa4fdc",
  null
  
)

export default component.exports